import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const TextAreaInput = ({
  value,
  onChange,
  placeholder,
  autoSize = { minRows: 3, maxRows: 6 },
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <Input.TextArea
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      autoSize={autoSize}
      style={{
        backgroundColor: theme.backgroundSecondary,
        color: theme.primary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

TextAreaInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  autoSize: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      minRows: PropTypes.number,
      maxRows: PropTypes.number,
    }),
  ]),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default TextAreaInput; 